import React, { useMemo } from 'react';
import { CollapsableCard } from '@eogile/agrements-common/src/components/card/CollapsableCard';
import { Grid } from '@mui/material';
import TextFieldAdapter from '@eogile/agrements-common/src/form/components/TextFieldAdapter';
import { Form } from 'react-final-form';
import { FdjUsersFilterValues } from '../fdjUsersTypes';
import AgencySelect from '@eogile/agrements-common/src/components/agencies/AgencySelect';
import { computeAgencyName } from '../../../demand/fdjDemandUtils';
import { EnumSelectAdapter } from '@eogile/agrements-common/src/form/components/EnumSelectAdapter';
import { FdjUserProfile } from '../../fdjUserTypes';
import { fdjProfileDisplayLabels } from '../../fdjUserUtils';
import FormFiltersListener from '@eogile/agrements-common/src/form/components/FormFiltersListener';
import { formValuesToQueryString } from '@eogile/agrements-common/src/utils/tableUtils';
import { hasAtLeastOneFilterValue } from '@eogile/agrements-common/src/utils/filtersUtils';

type Props = {
  filterValues: FdjUsersFilterValues;
};

/**
 * Component in charge of displaying the filters and updating
 * the query string when values change.
 */
const FdjUsersFilters = ({ filterValues }: Props) => {
  const defaultOpened = useMemo(() => hasAtLeastOneFilterValue(filterValues), [filterValues]);
  return (
    <CollapsableCard defaultOpened={defaultOpened} title="Critères">
      <Form initialValues={filterValues} onSubmit={() => {}}>
        {() => (
          <Grid container columnSpacing={2}>
            <FormFiltersListener transformValues={formValuesToQueryString(filterValues)} />
            <Grid item container sm={6} xs={12} rowSpacing={2}>
              <Grid item xs={12}>
                <TextFieldAdapter name="login" label="Login" />
              </Grid>
              <Grid item xs={12}>
                <TextFieldAdapter name="lastName" label="Nom" />
              </Grid>
              <Grid item xs={12}>
                <EnumSelectAdapter
                  label="Rôle"
                  name="profile"
                  options={Object.values(FdjUserProfile)}
                  optionName={(profileCode) => fdjProfileDisplayLabels[profileCode]}
                />
              </Grid>
            </Grid>
            <Grid item container sm={6} xs={12} rowSpacing={2} alignContent="flex-start">
              <Grid item xs={12}>
                <TextFieldAdapter name="email" label="Email" />
              </Grid>
              <Grid item xs={12}>
                <AgencySelect agencyName={computeAgencyName} disabled={false} fieldLabel="Secteur" />
              </Grid>
            </Grid>
          </Grid>
        )}
      </Form>
    </CollapsableCard>
  );
};

export default FdjUsersFilters;
